/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastVerified/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function LastVerified({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/LastVerified",
  hideLastVerified,
  onChange
  
}) {
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
let planDetailsLastVerifiedValueData = fromData.useDataFormat({ viewPath,
context: 'plan_details',
path: 'last_verified',
format: fromFormat.dateISOIn,
})
let planDetailsLastVerifiedChangeData = fromData.useDataChange({ viewPath,
context: 'plan_details',
path: 'last_verified',
formatOut: fromHelpers.formatOutDate,
})
  return (<React.Fragment
>
<fromFlow.When is={!hideLastVerified}>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 disabled={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
 type="text"
 data="plan_details.last_verified"
 format="/Data/format.js dateISOIn"
 formatOut="helpers.js formatOutDate"
 value={planDetailsLastVerifiedValueData}
 onChange={planDetailsLastVerifiedChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Last Verified"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</fromFlow.When>
{children}
</React.Fragment>)
}